import { t } from '@lingui/core/macro'
import { ORPCError, type ORPCErrorOptions } from '@orpc/client'
import { defineErrorRegistry } from '@pkg/shared/errors/registry'
import type { AppErrorCode } from './codes'

export type AppErrorOptions<C = unknown> = ORPCErrorOptions<C> & {
  registry?: string
  severity?: 'transient' | 'permanent' | 'fatal'
}

export class AppError<TCode extends AppErrorCode, TData> extends ORPCError<TCode, TData> {
  readonly severity?: 'transient' | 'permanent' | 'fatal'
}

export function isAppError<TCode extends AppErrorCode = AppErrorCode, TData = unknown>(
  err: unknown,
): err is AppError<TCode, TData> {
  if (err instanceof AppError) return true
  if (typeof err === 'object' && err !== null) {
    const e = err as { name?: unknown; key?: unknown }
    return e.name === 'AppError' && typeof e.key === 'string'
  }
  return false
}

export const appError = defineErrorRegistry('app', {
  VALIDATION: {
    severity: 'warn',
    description: t`Validierung fehlgeschlagen`,
  },
} as const)
